/* Rio wake-up page (Oct 7 2026). Reveal-on-scroll, the cold-open lines, the scan illustration
   and the evening stage. The device type and time are read locally and never sent anywhere. */
(function () {
  var root = document.querySelector('[data-rwk]');
  if (!root) return;
  root.classList.add('is-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Cold open: local time and a friendly device name.
  var ua = navigator.userAgent || '';
  var device = /iPhone/.test(ua) ? 'iPhone' : /iPad/.test(ua) ? 'iPad' : /Android/.test(ua) ? (/Mobile/.test(ua) ? 'phone' : 'tablet')
    : /Macintosh/.test(ua) ? (navigator.maxTouchPoints > 1 ? 'iPad' : 'Mac') : /Windows/.test(ua) ? 'computer' : 'screen';
  var d = new Date(), h = d.getHours(), m = d.getMinutes();
  var time = ((h % 12) || 12) + ':' + (m < 10 ? '0' : '') + m + (h < 12 ? ' a.m.' : ' p.m.');
  root.querySelectorAll('[data-rwk-now]').forEach(function (el) { el.textContent = time; });
  root.querySelectorAll('[data-rwk-device]').forEach(function (el) { el.textContent = device; });

  var lines = root.querySelectorAll('.rwk-open__line');
  lines.forEach(function (el, i) {
    if (reduce) { el.classList.add('is-in'); return; }
    setTimeout(function () { el.classList.add('is-in'); }, 400 + i * 1300);
  });

  if (!('IntersectionObserver' in window)) {
    root.querySelectorAll('.rwk-reveal').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  // Reveal blocks as they scroll in.
  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  root.querySelectorAll('.rwk-reveal').forEach(function (el) { rio.observe(el); });

  // Evening and rewind stages: the step in the middle of the screen picks the scene and the clock.
  // The clock ticks through the seconds; only the visible scene's video plays.
  function fmtClock(hm, sec) {
    var p = String(hm || '').split(':'), h = parseInt(p[0], 10) || 0, mm = p[1] || '00';
    var ss = (sec < 10 ? '0' : '') + sec;
    return h + ':' + mm + '<span class="rwk-sec">:' + ss + '</span> p.m.';
  }
  root.querySelectorAll('[data-rwk-eve]').forEach(function (sec) {
    var stage = sec.querySelector('.rwk-eve__stage');
    var clock = sec.querySelector('[data-rwk-clock]');
    var cur = null, s = 0, tickT = 0, inView = false;
    function setVideo() {
      sec.querySelectorAll('.rwk-eve__shot').forEach(function (shot) {
        var v = shot.querySelector('video'); if (!v) return;
        var on = inView && shot.getAttribute('data-shot') === stage.getAttribute('data-step');
        if (on && !reduce) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          var pr = v.play(); if (pr && pr.then) pr.then(function () { v.classList.add('is-playing'); }).catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }
    function tick() { if (!cur || !clock) return; s = (s + 1) % 60; clock.innerHTML = fmtClock(cur, s); }
    var stepIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        sec.querySelectorAll('.rwk-eve__step.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        e.target.classList.add('is-active');
        stage.setAttribute('data-step', e.target.getAttribute('data-step'));
        cur = e.target.getAttribute('data-clock'); s = Math.floor(Math.random() * 20);
        if (clock) clock.innerHTML = fmtClock(cur, s);
        setVideo();
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    sec.querySelectorAll('.rwk-eve__step').forEach(function (el) { stepIO.observe(el); });
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting;
      clearInterval(tickT);
      if (inView && !reduce) tickT = setInterval(tick, 1000);
      setVideo();
    }, { threshold: 0 }).observe(sec);
  });

  // Rewind title glitches once as it arrives.
  var rew = root.querySelector('.rwk-glitch');
  if (rew && !reduce) {
    var gio = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      gio.disconnect();
      rew.classList.add('is-glitching');
      setTimeout(function () { rew.classList.remove('is-glitching'); }, 2000);
    }, { threshold: 0.6 });
    gio.observe(rew);
  }

  // Scan illustration: a sweep across a field of dots; a few turn red.
  var scan = root.querySelector('[data-rwk-scan]');
  if (!scan) return;
  var cv = scan.querySelector('canvas'), ctx = cv.getContext('2d');
  var outChecked = scan.querySelector('[data-rwk-checked]'), outOpen = scan.querySelector('[data-rwk-open]');
  var TOTAL = 4294967296, dots = [], cols = 0, rows = 0, gap = 14, dpr = 1, running = false, t0 = 0, raf = 0;
  var DURATION = 9000;
  function layout() {
    dpr = Math.min(2, window.devicePixelRatio || 1);
    var w = cv.clientWidth, hgt = cv.clientHeight;
    cv.width = w * dpr; cv.height = hgt * dpr;
    gap = w < 600 ? 11 : 14;
    cols = Math.floor(w / gap); rows = Math.floor(hgt / gap);
    dots = [];
    var seed = 7;
    for (var i = 0; i < cols * rows; i++) {
      seed = (seed * 16807) % 2147483647;
      dots.push(seed / 2147483647 < 0.018);
    }
  }
  function draw(p) {
    var w = cv.width, hgt = cv.height;
    ctx.clearRect(0, 0, w, hgt);
    var sweep = p * (cols + 6);
    var open = 0;
    for (var y = 0; y < rows; y++) {
      for (var x = 0; x < cols; x++) {
        var i = y * cols + x, cx = (x + 0.5) * gap * dpr, cy = (y + 0.5) * gap * dpr;
        var passed = x < sweep, near = Math.abs(x - sweep) < 2;
        if (passed && dots[i]) { open++; ctx.fillStyle = 'rgba(255,90,78,0.95)'; ctx.beginPath(); ctx.arc(cx, cy, 2.6 * dpr, 0, 6.283); ctx.fill(); continue; }
        ctx.fillStyle = near ? 'rgba(238,243,245,0.85)' : passed ? 'rgba(238,243,245,0.22)' : 'rgba(238,243,245,0.08)';
        ctx.fillRect(cx - 1 * dpr, cy - 1 * dpr, 2 * dpr, 2 * dpr);
      }
    }
    var checked = Math.min(TOTAL, Math.round(TOTAL * p));
    outChecked.textContent = checked.toLocaleString('en-US');
    outOpen.textContent = open.toLocaleString('en-US');
  }
  function tick(now) {
    if (!t0) t0 = now;
    var p = Math.min(1, (now - t0) / DURATION);
    draw(p);
    if (p < 1 && running) raf = requestAnimationFrame(tick);
  }
  layout();
  draw(reduce ? 1 : 0);
  window.addEventListener('resize', function () { layout(); draw(reduce || !running ? (t0 ? 1 : 0) : 0); });
  if (reduce) return;
  var scanIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting && !running && !t0) { running = true; raf = requestAnimationFrame(tick); }
    });
  }, { threshold: 0.4 });
  scanIO.observe(cv);
})();
